import Vue from 'vue'
import service from '../services/vendor-documents-service'

export function useDocuments() {
  const state = Vue.observable({
    items: [],
    currentPage: 1,
    lastPage: 1,
    loading: false
  })

  async function getVendorDocuments(params = {}) {
    state.loading = true
    try {
      const response = await service.getVendorDocuments(params)
      state.items = response.vendors.current_page === 1
        ? [...response.vendors.data]
        : [...state.items, ...response.vendors.data]
      state.currentPage = response.vendors.current_page
      state.lastPage = response.vendors.last_page
      state.loading = false
      return { success: true, response }
    } catch (err) {
      return { success: false, error: err }
    } finally {
      state.loading = false
    }
  }

  async function getDocumentCatalog(params = {}) {
    state.loading = true
    try {
      const response = await service.getDocumentCatalog(params)
      state.loading = false
      return { success: true, response }
    } catch (err) {
      return { success: false, error: err }
    } finally {
      state.loading = false
    }
  }

  async function vendorDocumentStore(params = {}) {
    state.loading = true
    try {
      const response = await service.vendorDocumentStore(params)
      state.items = [...state.items,response.document]
      state.loading = false
      return { success: true, response }
    } catch (err) {
      return { success: false, error: err }
    } finally {
      state.loading = false
    }
  }


  return { state, getVendorDocuments, getDocumentCatalog, vendorDocumentStore }
}
